import type { BlockTemplate, RelatedProductRenderer } from '@zoomit/editor';

import FeaturedProductsList from './FeaturedProductsList';
import RelatedProductList from './RelatedProductList';
import RelatedProductSingleWrapper from './RelatedProductSingleWrapper';
import RelatedProductSlider from './RelatedProductSlider';

type Props = {
  template: BlockTemplate['related-product'];
  blockData: RelatedProductRenderer;
  blockId: string;
};

const RelatedProductBlock = (props: Props) => {
  const { template, blockData, blockId } = props;

  switch (template) {
    case 'product_list':
      return <RelatedProductList blockData={blockData} />;
    case 'product_slider':
      return <RelatedProductSlider blockData={blockData} blockId={blockId} />;
    case 'featured_product':
      return <FeaturedProductsList blockData={blockData} />;
    case 'single_product_simple':
    case 'single_product_pros_cons':
    case 'single_product_complete':
      return <RelatedProductSingleWrapper template={template} blockData={blockData} />;
    default:
      return null;
  }
};

export default RelatedProductBlock;
